import { RequestContext, HttpMethod, CookieStrategy } from "./http";

export interface BaseServerConfiguration {
    makeRequestContext(endpoint: string, httpMethod: HttpMethod): RequestContext;
}

/**
 *
 * Represents the configuration of a server including its
 * url template and variable configuration based on the url.
 *
 */
export class ServerConfiguration<T extends { [key: string]: string }> implements BaseServerConfiguration {
    public constructor(
        private url: string,
        private variableConfiguration: T,
        private cookieStrategy: CookieStrategy = 'same-origin'
    ) {}

    /**
     * Sets the value of the variables of this server.
     *
     * @param variableConfiguration a partial variable configuration for the variables contained in the url
     */
    public setVariables(variableConfiguration: Partial<T>): void {
        Object.assign(this.variableConfiguration, variableConfiguration);
    }

	public getConfiguration(): T {
		return this.variableConfiguration
	}

	private getUrl(): string {
		/**
		 * Handling the default server url (`/`) which when combined with an endpoint will result 
		 * in an invalid URL.
		 */
		let replacedUrl = this.url === '/' ? '' : this.url;
		for (const key in this.variableConfiguration) {
			var re = new RegExp("{" + key + "}","g");
			replacedUrl = replacedUrl.replace(re, this.variableConfiguration[key]);
		}
		return replacedUrl
	}

    public setCookieStrategy(strategy: CookieStrategy): void {
        this.cookieStrategy = strategy;
    }

    public getCookieStrategy(): CookieStrategy {
        return this.cookieStrategy;
    }

	/**
	 * Creates a new request context for this server using the url with variables
	 * replaced with their respective values and the endpoint of the request appended.
	 *
	 * @param endpoint the endpoint to be queried on the server
	 * @param httpMethod httpMethod to be used
	 *
	 */	
	public makeRequestContext(endpoint: string, httpMethod: HttpMethod): RequestContext {
		return new RequestContext(this.getUrl() + endpoint, httpMethod, this.cookieStrategy);
	}
}

export const server1 = new ServerConfiguration<{  }>("https://api.truvity.com", {  })

export const servers = [server1];
